"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-two/sections/appSection.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AppSectionDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "apple-icon" | "google-play" */
    alt: string;
    /** Detected variants: "/Templates/Doccure/img/icons/app-store.svg" | "/Templates/Doccure/img/icons/google-play.svg" */
    src: string;
    /** Detected variants: "#" */
    href?: string;
};

type AppSectionSwipersItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/company/company-09.svg" | "/Templates/Doccure/img/company/company-10.svg" | "/Templates/Doccure/img/company/company-11.svg" | "/Templates/Doccure/img/company/company-12.svg" | "/Templates/Doccure/img/company/company-13.svg" | "/Templates/Doccure/img/company/company-14.svg" */
    src: string;
    /** Detected variants: "slide-item" */
    className?: string;
    /** Detected variants: "client logo" */
    alt?: string;
};
export type HomeTwoAppSectionGeneratedProps = {
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: AppSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    linkImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AppSectionDivsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
    sectionDiv0Div1Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div1Div0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "Download the Doccure App today!" */
    sectionDiv0Div1Div0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div1Div0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div1Div0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Working for Your Better Health." */
    sectionDiv0Div1Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "1s" */
    sectionDiv0Div1Div0Div0Div0Div1DivDataWowDuration?: string;
    /** Default: "1s" */
    sectionDiv0Div1Div0Div1DivDataWowDuration?: string;
    /** Default: "app" */
    sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/app-01.png" */
    sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    sectionDiv0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/app-bg-05.png" */
    sectionDiv0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    swiperSlideSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: AppSectionSwipersItem) => Partial<ComponentProps<typeof SwiperSlide>>);
    swiperSlideDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AppSectionSwipersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    appSectionDivs: AppSectionDivsItem[];
    appSectionSwipers: AppSectionSwipersItem[];
    appSectionDivsItemWrapper?: (item: AppSectionDivsItem, content: ReactNode) => ReactNode;
    appSectionDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    appSectionDivsLinkVisible?: boolean;
    appSectionDivsLinkRenderer?: (item: AppSectionDivsItem, defaultNode: ReactNode) => ReactNode;
    appSectionDivsImageVisible?: boolean;
    appSectionDivsImageRenderer?: (item: AppSectionDivsItem, defaultNode: ReactNode) => ReactNode;
    appSectionDivsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: AppSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    appSectionDivsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AppSectionDivsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    appSectionSwipersItemWrapper?: (item: AppSectionSwipersItem, content: ReactNode) => ReactNode;
    appSectionSwipersRenderer?: (defaultNode: ReactNode) => ReactNode;
    appSectionSwipersImageVisible?: boolean;
    appSectionSwipersImageRenderer?: (item: AppSectionSwipersItem, defaultNode: ReactNode) => ReactNode;
    appSectionSwipersImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AppSectionSwipersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    appSectionSwipersSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: AppSectionSwipersItem) => Partial<ComponentProps<typeof SwiperSlide>>);
};

const HomeTwoAppSectionGenerated: FC<HomeTwoAppSectionGeneratedProps> = ({
    sectionDiv0Div1Div0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div1Div0Div0Div0Div0H20H2Text = "Download the Doccure App today!",
    sectionDiv0Div1Div0Div0Div0Div0H20H2Visible,
    sectionDiv0Div1Div0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div1Div0Div0Div0Div0H20H2Props,
    sectionDiv0Div1Div0Div0Div0Div0P0PText = "Working for Your Better Health.",
    sectionDiv0Div1Div0Div0Div0Div1DivDataWowDuration = "1s",
    sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageAlt = "app",
    sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/app-01.png",
    sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div0Div1DivDataWowDuration = "1s",
    sectionDiv0Div1ImageWithBasePath0ImageAlt = "img",
    sectionDiv0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/app-bg-05.png",
    sectionDiv0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1ImageWithBasePath0ImageProps,
    linkImageWithBasePath0ImageProps,
    linkLinkProps,
    sectionDiv0Div0Swiper0SwiperProps,
    swiperSlideDiv0ImageWithBasePath0ImageProps,
    swiperSlideSwiperSlideProps,
    sectionDiv0Div1Div0ClassName,
    appSectionDivs,
    appSectionSwipers,
    appSectionDivsItemWrapper,
    appSectionDivsRenderer,
    appSectionDivsLinkVisible,
    appSectionDivsLinkRenderer,
    appSectionDivsImageVisible,
    appSectionDivsImageRenderer,
    appSectionDivsLinkProps,
    appSectionDivsImageProps,
    appSectionSwipersItemWrapper,
    appSectionSwipersRenderer,
    appSectionSwipersImageVisible,
    appSectionSwipersImageRenderer,
    appSectionSwipersImageProps,
    appSectionSwipersSwiperSlideProps,
}) => {
    return (
        <section className="app-section-two">
            <div className="container">
                <div className="company-slider-two">
                    <Swiper modules={[Autoplay]} loop={true} speed={2000} autoplay={{
                        delay: 0,
                        disableOnInteraction: false,
                    }} slidesPerView={6} slidesPerGroup={1} spaceBetween={20} breakpoints={{
                        1400: {
                            slidesPerView: 6
                        },
                        1200: {
                            slidesPerView: 4
                        },
                        992: {
                            slidesPerView: 3
                        },
                        768: {
                            slidesPerView: 3
                        },
                        576: {
                            slidesPerView: 3
                        },
                        0: {
                            slidesPerView: 1
                        }
                    }} {...(sectionDiv0Div0Swiper0SwiperProps ?? {})}>
                        {renderCollectionNode(
                            appSectionSwipers,
                            (item: AppSectionSwipersItem) => (
                                <SwiperSlide {...(typeof appSectionSwipersSwiperSlideProps === "function" ? appSectionSwipersSwiperSlideProps(item) : (appSectionSwipersSwiperSlideProps ?? {}))} {...(typeof swiperSlideSwiperSlideProps === "function" ? swiperSlideSwiperSlideProps(item) : (swiperSlideSwiperSlideProps ?? {}))} key={item.key}>
                                    <div className={item.className ?? "slide-item"}>
                                        {renderItemNode(appSectionSwipersImageVisible, appSectionSwipersImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "client logo"} {...(typeof appSectionSwipersImageProps === "function" ? appSectionSwipersImageProps(item) : (appSectionSwipersImageProps ?? {}))} {...(typeof swiperSlideDiv0ImageWithBasePath0ImageProps === "function" ? swiperSlideDiv0ImageWithBasePath0ImageProps(item) : (swiperSlideDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                </SwiperSlide>
                            ),
                            appSectionSwipersItemWrapper,
                            appSectionSwipersRenderer
                        )}
                    </Swiper>
                </div>
                <div className="app-sec">
                    <div className={sectionDiv0Div1Div0ClassName ?? "row align-items-end"}>
                        <div className="col-lg-6">
                            <div className="app-content d-flex flex-column justify-content-center">
                                <div className="section-header sec-header-one wow fadeInUp" data-wow-duration={sectionDiv0Div1Div0Div0Div0Div0DivDataWowDuration}>
                                    <p className="sub-title">{sectionDiv0Div1Div0Div0Div0Div0P0PText}</p>
                                    {renderNode(sectionDiv0Div1Div0Div0Div0Div0H20H2Visible, sectionDiv0Div1Div0Div0Div0Div0H20H2Renderer, (
                                        <h2 className="section-title" {...(sectionDiv0Div1Div0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div1Div0Div0Div0Div0H20H2Text}</h2>
                                    ))}
                                </div>
                                <div className="app-imgs wow fadeInUp" data-wow-duration={sectionDiv0Div1Div0Div0Div0Div1DivDataWowDuration}>
                                    {renderCollectionNode(
                                        appSectionDivs,
                                        (item: AppSectionDivsItem) => (
                                            renderItemNode(appSectionDivsLinkVisible, appSectionDivsLinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} {...(typeof appSectionDivsLinkProps === "function" ? appSectionDivsLinkProps(item) : (appSectionDivsLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                                    {renderItemNode(appSectionDivsImageVisible, appSectionDivsImageRenderer, item, (
                                                        <SmartImage src={item.src} alt={item.alt} {...(typeof appSectionDivsImageProps === "function" ? appSectionDivsImageProps(item) : (appSectionDivsImageProps ?? {}))} {...(typeof linkImageWithBasePath0ImageProps === "function" ? linkImageWithBasePath0ImageProps(item) : (linkImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </SmartLink>
                                            ))
                                        ),
                                        appSectionDivsItemWrapper,
                                        appSectionDivsRenderer
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 wow fadeInUp" data-wow-duration={sectionDiv0Div1Div0Div1DivDataWowDuration}>
                            <div className="app-img">
                                {renderNode(sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageSrc} className="img-fluid" alt={sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div1Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                        </div>
                    </div>
                    {renderNode(sectionDiv0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div1ImageWithBasePath0ImageRenderer, (
                        <SmartImage src={sectionDiv0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1ImageWithBasePath0ImageAlt} className="app-bg-01" {...(sectionDiv0Div1ImageWithBasePath0ImageProps ?? {})} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeTwoAppSectionGenerated;
